import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'src/utils/AxiosConfig'

// ** Add Project_cost
export const addProjectCost = createAsyncThunk(
  'appProjectCost/addProjectCost', // Corrected to match the name in createAsyncThunk
  async (data, { getState, dispatch, rejectWithValue }) => {
    try {
        if (!data) {
            throw new Error("Invalid data");
          }
      const response = await axios.post('/api/project_costs',data )
      return response.data
      
    } catch (error) {
      // Reject with the error message or any other error details you want
      return rejectWithValue(error.response ? error.response.data : error.message)
    }
  }
)

export const ProjectCostSlice = createSlice({
  name: 'ProjectCost',
  initialState: {
    singleData: {}, // Data for a single Project
    data: [], // Data for a list of Projects
    total: 0,
    params: {},
    allData: [], // (Optional) Store all Project data if needed
    status: 'idle',
    message: null,
    errors: null
  },
  reducers: {
    resetSingleProject: (state) => {
      state.singleData = {} // Reset single Project data
    },
    resetStateIdele: (state) => {
      state.status = 'idle' // Reset status to idle
    }
  },
  extraReducers: (builder) => {
    // ** Add Project Cost
    builder
      .addCase(addProjectCost.pending, (state) => {
        state.status = 'loading'
        state.message = null
        state.errors = null
      })
      .addCase(addProjectCost.fulfilled, (state) => {
        state.status = 'succeeded'
      })
      .addCase(addProjectCost.rejected, (state, action) => {
        state.status = 'failed'
        state.message = action.payload.message
        state.errors = Object.values(action.payload.errors).flat()
      })
  }
})

export const { resetSingleProject, resetStateIdele } = ProjectCostSlice.actions

export default ProjectCostSlice.reducer